import { computed, inject } from '@angular/core';

import { patchState, signalStore, withComputed, withMethods, withState } from '@ngrx/signals';

import { CountrySearchParams, EaCountriesList, EaCountry } from '../../models/custom-climate.model';
import { EaCountryService } from '../../services/ea-country.service';

type EaCountriesState = {
  paginatedData: EaCountriesList;
  textSearch: string;
  continentId: string | null;
  currentPage: number;
  pageSize: number;
  isLoading: boolean;
};

const initialState: EaCountriesState = {
  paginatedData: { elements: [], totalElements: 0, totalPages: 0 },
  textSearch: '',
  continentId: null,
  currentPage: 1,
  pageSize: 1000,
  isLoading: false,
};

export const EaCountriesStore = signalStore(
  withState(initialState),
  withComputed(store => ({
    requestParameters: computed<CountrySearchParams>(() => ({
      text: store.textSearch(),
      continentId: store.continentId() ?? undefined,
      orderByField: 'NAME',
      orderByDirection: 'ASC',
      page: store.currentPage(),
      pageSize: store.pageSize(),
    })),
    countries: computed<EaCountry[]>(() => store.paginatedData().elements),
  })),
  withMethods((store, service = inject(EaCountryService)) => ({
    loadByContinent: (continentId: string) => {
      patchState(store, { continentId, currentPage: 1, isLoading: true });
      service
        .search({
          text: store.textSearch(),
          continentId,
          orderByField: 'NAME',
          orderByDirection: 'ASC',
          page: 1,
          pageSize: store.pageSize(),
        })
        .subscribe({
          next: response => patchState(store, { isLoading: false, paginatedData: response }),
          error: () => patchState(store, { isLoading: false }),
        });
    },
    clear: () => patchState(store, initialState),
  }))
);
